<!--
트래킹검수 > 푸터
------------------------------------
-->
<template>
    <div class="footer-bar uk-flex uk-flex-between uk-flex-bottom">

        <div class="uk-margin-right">
            <a @click="moveMain" class="uk-logo" title="지역 > 메인으로 이동">
                <span class="uk-text-middle" uk-icon="icon: home; ratio: 1.25;"></span>
                MAIN
            </a>
        </div>
        <div class="uk-margin-right">
            <a @click="moveShipInScan" class="link" title="입고스캔으로 이동">
                <i class="material-icons md-24 uk-text-middle">aspect_ratio</i>
                입고스캔
            </a>
        </div>
        <div class="uk-margin-right">
            <a @click="moveNodataScan" class="link" title="무자료확인으로 이동">
                <i class="material-icons md-24 uk-text-middle">aspect_ratio</i>
                무자료확인
            </a>
        </div>
        <div class="uk-margin-right">
            <a @click="moveTrackingCheck" class="link" title="입고스캔으로 이동">
                <i class="material-icons md-24 uk-text-middle">aspect_ratio</i>
                트래킹검수
            </a>
        </div>

        <div class="uk-width-expand">
        </div>

        <div class="uk-margin-right">
            <!-- 무자료등록 기준일 선택 -->
            무자료등록 기준
            <p-radio
                v-for="(days, index) in nodataOverdaysFromShipinOptions"
                :key="index"
                class="p-default p-curve"
                name="radio-check-mode"
                color="warning"
                :value="days"
                :checked="nodataOverdaysFromShipin === days"
                v-on:change="$emit('update:nodataOverdaysFromShipin', $event)"
            >
                <i slot="extra" class="icon mdi mdi-check"></i>
                {{ days }}일경과
            </p-radio>
        </div>


        <div class="">
            작업자 : {{ loginUserName }}
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

            /**
             * 무자료등록 기준일
             */
            nodataOverdaysFromShipin: {
                type: Number,
            },

        },
        data: function () {
            return {
                nodataOverdaysFromShipinOptions: [3, 4, 5,],
            };
        },
        computed: {

        },
        methods: {
            /**
             * 메인으로 이동
             */
            moveMain: function () {
                $.app.move('/regions/'+this.regionId);
            },

            /**
             * 입고스캔 이동
             */
            moveShipInScan: function () {
                $.app.move('/regions/'+this.regionId+'/ship-ins/scan');
            },

            /**
             * 무자료확인 이동
             */
            moveNodataScan: function () {
                $.app.move('/regions/'+this.regionId+'/nodata-scan');
            },

            /**
             * 트래킹검수 이동
             */
            moveTrackingCheck: function () {
                $.app.move('/regions/'+this.regionId+'/tracking-check');
            },


        },
    }
</script>

<style lang="scss" scoped>
    .footer-bar{
        border: 0;
        padding: 10px;
        background-color: #286540 !important;
        color: #fff;
        font-size: 1rem;

        .uk-logo {
            font-family: Audiowide,cursive;
            color: rgb(238, 241, 245);
            font-size: 1.25rem;
        }

        .link {
            color: rgb(238, 241, 245);
            font-size: 1.25rem;
        }
    }
</style>